import { Injectable } from '@angular/core';
import { Api, UserMyRadiant as User } from '../../';

@Injectable()
export class TrackingFasker {

  active = 0;
  review = 0;
  data:any = {};
  
  constructor(public api: Api, public user:User) { }

  getItem(params : any){
    return this.api.get('index.php/asset/fasker/item', params)
  }

  getDetail(params?: any) {
    if(params.id==undefined){
      params.id = 0;
    }
    return this.api.get('index.php/asset/fasker/detail/'+params.id, params);
  }

  getItemTracking(params?:any){
    return this.api.get('index.php/asset/fasker/itemTracking', params);
  }

  getItemFaskerTracking(params : any){
    return this.api.get('index.php/asset/fasker/itemFaskerTracking', params);
  }

  getTrackedItem(params : any){
    return this.api.get('index.php/asset/fasker/trackedItem', params);
  }

  post(params : any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/fasker/itemTrack', params);
  }

  saveItem(params : any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    params.updated_by = this.user.data.employee_id;
    return this.api.post('index.php/asset/fasker/item', params);
  }

  getImages(params?: any) {
    return this.api.get('index.php/asset/fasker/images', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/asset/tracking/trackingFasker.ts